import axios from 'axios';

export const isEditablePage = (path) => {
  return path.startsWith('/publish') || path.startsWith('/user/fill-form/');
};

export const uploadImageToServer = async ({ image, token, FormId, setImage, setImageId, setLoading, toast, CustomToast }) => {
  if (!token || !FormId || !image) {
    console.error('Missing required fields for upload');
    setTimeout(() => setImage(null), 2000);
    return;
  }

  setLoading(true);

  try {
    const response = await axios.post(
      `https://formmaker-api.altynlogistics.com/api/form/${FormId}/image`,
      { image },
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (response.data.errors.length > 0) {
      toast(<CustomToast message={response.data.errors} />);
      setTimeout(() => setImage(null), 2000);
    } else {
      setImageId(response.data.output.id);
    }

  } catch (error) {
    console.error('Upload failed:', error);
    setTimeout(() => setImage(null), 2000);
  } finally {
    setLoading(false);
  }
};

export const syncImageIdWithDrawer = (drawerData, index, imageId) => {
  if (drawerData[index]) {
    drawerData[index].state.mainImage = imageId;
  }
};
